export const MENTION_REGEX =
  /\[(file|section|document|range|template|library|skill):([^\]]+)\]/g;

export const MENTION_DATA_ID_REGEX = new RegExp(`^${MENTION_REGEX.source}$`);
